/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconvertersource2Inputs */

const en_formatconvertersource2 = /** @type {(inputs: Formatconvertersource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source image`)
};

const de_formatconvertersource2 = /** @type {(inputs: Formatconvertersource2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellbild`)
};

/**
* | output |
* | --- |
* | "Source image" |
*
* @param {Formatconvertersource2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconvertersource2 = /** @type {((inputs?: Formatconvertersource2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconvertersource2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconvertersource2(inputs)
	return de_formatconvertersource2(inputs)
});
export { formatconvertersource2 as "formatConverterSource" }